/* Slouch homepage hero: dumpling stampede (Oct 2026).
   Four dumplings pop out of the PJ print on the "2 pairs. $149." hero, two say a line, all run off.
   Plays once per browser session, never for reduced motion. Pointer events pass through to the hero link.
   Positions are percentages of the visible hero image (desktop 5760x2560, mobile 2160x2700). */
(function () {
  if (window.__spwDumplingRun) return; window.__spwDumplingRun = true;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  try { if (sessionStorage.getItem('spwDumplingRun')) return; } catch (e) {}
  if (!Element.prototype.animate) return;

  var BAO = window.SPW_BAO_SRC;
  var SAY = [null, '2 for $149?! RUN', "outraged. we're worth more!", null];
  function D(x, y, floor, delay, e) { return Object.assign({ x: x, y: y, floor: floor, delay: delay, exit: 112, size: 5.6, lift: 9, pace: 24 }, e); }
  function M(x, y, floor, delay, exit, e) { return Object.assign({ x: x, y: y, floor: floor, delay: delay, exit: exit, size: 14, lift: 7, pace: 32 }, e); }
  var SCENES = {
    desk: [D(61.5, 54, 90, 800, { size: 4.8, eep: SAY[0], say: 2200 }), D(63, 72, 91, 1500, { size: 4.4, lift: 6, pace: 20, eep: SAY[1], say: 2000 }),
           D(84, 46, 88, 2200, { size: 4.8, pace: 21, eep: SAY[2], say: 2000 }), D(86.5, 66, 89, 2900, { size: 4.4, lift: 6, pace: 18, eep: SAY[3], say: 1900 })],
    mob: [M(22, 64, 87, 800, -14, { size: 12, eep: SAY[0], say: 2200 }), M(30, 80, 88, 1500, -14, { size: 11, lift: 5, pace: 28, eep: SAY[1], say: 2000 }),
          M(79, 61, 86, 2200, 114, { size: 12, eep: SAY[2], say: 2000 }), M(72, 78, 87, 2900, 114, { size: 11, lift: 5, pace: 28, eep: SAY[3], say: 1900 })]
  };

  var css = '.spw-dr{position:absolute;pointer-events:none;overflow:hidden;z-index:3;container-type:inline-size}' +
    '.spw-dr .bao{position:absolute;transform:translate(-50%,-100%)}' +
    '.spw-dr .body{transform-origin:50% 100%}.spw-dr .flip{position:relative}' +
    '.spw-dr img{display:block;width:100%;height:auto;position:relative;z-index:1;filter:drop-shadow(0 2px 2px rgba(42,29,31,.18))}' +
    '.spw-dr .legs{position:absolute;left:18%;width:64%;bottom:-26%;height:34%;opacity:0;overflow:visible}' +
    '.spw-dr .legs path{fill:none;stroke:#4a2a33;stroke-width:5;stroke-linecap:round;stroke-linejoin:round}' +
    '.spw-dr .l1,.spw-dr .l2{transform-box:fill-box;transform-origin:50% 0}' +
    '.spw-dr .running .legs{opacity:1}.spw-dr .running .l1{animation:spwkick .22s ease-in-out infinite alternate}' +
    '.spw-dr .running .l2{animation:spwkick .22s ease-in-out infinite alternate-reverse}' +
    '@keyframes spwkick{from{transform:rotate(-38deg)}to{transform:rotate(38deg)}}' +
    '.spw-dr .shadow{position:absolute;left:15%;width:70%;height:12%;bottom:-30%;border-radius:50%;background:rgba(42,29,31,.22);filter:blur(2px);opacity:0}' +
    '.spw-dr .running .shadow{opacity:1}' +
    '.spw-dr .puff{position:absolute;width:1.1%;aspect-ratio:1;border-radius:50%;background:#fffaf3;box-shadow:0 0 0 1.5px rgba(74,42,51,.35);transform:translate(-50%,-50%)}' +
    '.spw-dr.mob .puff{width:2.6%}' +
    '.spw-dr .eep{position:absolute;left:50%;bottom:112%;background:#fffaf3;color:#4a2a33;font:600 clamp(9px,1.1cqw,16px)/1 Poppins,system-ui,sans-serif;padding:.45em .7em;border-radius:999px;border:2px solid #4a2a33;white-space:nowrap;z-index:3;opacity:0}' +
    '.spw-dr.mob .eep{font-size:clamp(10px,3.2cqw,16px)}';

  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function puff(layer, x, y, n) {
    for (var i = 0; i < n; i++) {
      var p = document.createElement('span'); p.className = 'puff';
      p.style.left = x + '%'; p.style.top = y + '%'; layer.appendChild(p);
      var a = -(Math.PI * (0.15 + 0.7 * i / (n - 1))), r = 2.2 + Math.random() * 1.6;
      (function (p) {
        p.animate([{ transform: 'translate(-50%,-50%) scale(.4)', opacity: 1 },
          { transform: 'translate(calc(-50% + ' + (Math.cos(a) * r * 10) + 'cqw), calc(-50% + ' + (Math.sin(a) * r * 6) + 'cqw)) scale(1.3)', opacity: 0 }],
          { duration: 520 + Math.random() * 200, easing: 'cubic-bezier(.2,.7,.3,1)' }).finished.then(function () { p.remove(); });
      })(p);
    }
  }

  async function dumpling(layer, o) {
    var w = document.createElement('div'); w.className = 'bao';
    w.style.width = o.size + '%'; w.style.left = o.x + '%'; w.style.top = o.y + '%'; w.style.visibility = 'hidden';
    w.innerHTML = '<div class="body"><div class="flip"><svg class="legs" viewBox="0 0 60 30" aria-hidden="true"><path class="l1" d="M22 0 L19 22 L11 25"/><path class="l2" d="M38 0 L41 22 L49 25"/></svg><img src="' + BAO + '" alt=""><span class="shadow"></span></div></div>';
    layer.appendChild(w);
    var body = w.querySelector('.body'), flip = w.querySelector('.flip');
    var d = Math.sign(o.exit - o.x), face = d > 0 ? -1 : 1;
    flip.style.transform = 'scaleX(' + face + ')';
    await sleep(o.delay);
    w.style.visibility = 'visible';
    puff(layer, o.x, o.y - o.size * 0.35, 6);
    if (o.eep) {
      var b = document.createElement('span'); b.className = 'eep'; b.textContent = o.eep; w.appendChild(b);
      var tx = o.x < 35 ? '-15%' : o.x > 65 ? '-85%' : '-50%';
      b.animate([{ opacity: 0, transform: 'translateX(' + tx + ') scale(.4)' }, { opacity: 1, transform: 'translateX(' + tx + ') scale(1.1)', offset: .1 },
        { opacity: 1, transform: 'translateX(' + tx + ') scale(1)', offset: .85 }, { opacity: 0, transform: 'translateX(' + tx + ') scale(1)' }],
        { duration: o.say || 1500, delay: 250, fill: 'forwards' });
    }
    await body.animate([{ transform: 'scale(0,0) rotate(-25deg)', opacity: 0 }, { transform: 'scale(1.28,.68) rotate(10deg)', opacity: 1, offset: .45 },
      { transform: 'scale(.86,1.2) rotate(-5deg)', offset: .72 }, { transform: 'scale(1,1) rotate(0)' }],
      { duration: 560, easing: 'cubic-bezier(.3,1.4,.5,1)', fill: 'forwards' }).finished;
    await flip.animate([{ transform: 'scaleX(' + face + ')' }, { transform: 'scaleX(' + -face + ')', offset: .25 },
      { transform: 'scaleX(' + -face + ')', offset: .5 }, { transform: 'scaleX(' + face + ')', offset: .7 }, { transform: 'scaleX(' + face + ')' }],
      { duration: 760, easing: 'steps(1, end)', fill: 'forwards' }).finished;
    var x = o.x, y = o.y, f = o.floor;
    var hop = w.animate([
      { left: x + '%', top: y + '%', easing: 'cubic-bezier(.2,.6,.4,1)' },
      { left: (x + d * 2.5) + '%', top: (y - o.lift) + '%', easing: 'cubic-bezier(.6,0,.8,.4)', offset: .3 },
      { left: (x + d * 5) + '%', top: f + '%', easing: 'cubic-bezier(.2,.6,.4,1)', offset: .62 },
      { left: (x + d * 6.5) + '%', top: (f - o.lift * .45) + '%', easing: 'cubic-bezier(.6,0,.8,.4)', offset: .82 },
      { left: (x + d * 8) + '%', top: f + '%' }], { duration: 1050, fill: 'forwards' });
    body.animate([{ transform: 'scale(1,1)' }, { transform: 'scale(.9,1.12)', offset: .3 }, { transform: 'scale(1.3,.72)', offset: .62 },
      { transform: 'scale(.95,1.08)', offset: .72 }, { transform: 'scale(1,1)', offset: .82 }, { transform: 'scale(1.22,.8)', offset: .96 }, { transform: 'scale(1,1)' }],
      { duration: 1050, fill: 'forwards' });
    setTimeout(function () { puff(layer, x + d * 5, f, 4); }, 650);
    await hop.finished;
    w.classList.add('running');
    var from = x + d * 8, dist = Math.abs(o.exit - from);
    body.animate([{ transform: 'translateY(0) rotate(0)' }, { transform: 'translateY(-9%) rotate(' + (d * 6) + 'deg)' }],
      { duration: 140, iterations: Infinity, direction: 'alternate', easing: 'ease-in-out' });
    await w.animate([{ left: from + '%' }, { left: o.exit + '%' }], { duration: dist * o.pace, easing: 'cubic-bezier(.5,0,.9,.7)', fill: 'forwards' }).finished;
    w.remove();
  }

  function start() {
    var slide = document.querySelector('.promo-vi-hero .zpro-hero-slide');
    if (!slide || !BAO) return;
    var imgs = slide.querySelectorAll('img');
    var img = null;
    for (var i = 0; i < imgs.length; i++) { if (imgs[i].offsetWidth > 0 && /dumpling-2-for-149/.test(imgs[i].currentSrc || imgs[i].src)) { img = imgs[i]; break; } }
    if (!img) return;                          // a different hero is up: do nothing
    var mode = img.naturalWidth > img.naturalHeight || img.width > img.height ? 'desk' : 'mob';

    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    if (getComputedStyle(slide).position === 'static') slide.style.position = 'relative';
    var layer = document.createElement('div'); layer.className = 'spw-dr ' + mode; layer.setAttribute('aria-hidden', 'true');
    function place() {
      layer.style.left = img.offsetLeft + 'px'; layer.style.top = img.offsetTop + 'px';
      layer.style.width = img.offsetWidth + 'px'; layer.style.height = img.offsetHeight + 'px';
    }
    place(); slide.appendChild(layer); addEventListener('resize', place);

    var go = function () {
      try { sessionStorage.setItem('spwDumplingRun', '1'); } catch (e) {}
      var pre = new Image(); pre.src = BAO;
      (pre.decode ? pre.decode() : Promise.resolve()).catch(function () {}).then(function () {
        place();
        Promise.all(SCENES[mode].map(function (o) { return dumpling(layer, o); })).then(function () { layer.remove(); });
      });
    };
    var ready = function () {
      if (!('IntersectionObserver' in window)) return go();
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); go(); } }, { threshold: .5 });
      io.observe(img);
    };
    if (img.complete && img.naturalWidth) ready(); else img.addEventListener('load', ready, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
